export default __webpack_public_path__ + "static/media/10.532163df.svg";